import React from 'react';
import { useEffect } from "react";
import { Helmet } from 'react-helmet';
import "../../../../assets/css/style.css";
import Form from './Form.js'
import PatientReviews from '../../PatientReview.js';

import GetInTouch from '../../GetInTouch.js';
import FollowYt from '../../FollowYt.js'
import ContentWithImages from './ContentWithImages.js'
import DoctorBite from '../../DoctorBite.js';
import Counter from '../../../NumCounter.js';
import Breadcrumb from '../../Breadcrum.js';


export default function Index() {
  useEffect(() => {
    const metaTags = document.getElementsByTagName('meta');
    Array.from(metaTags).forEach((tag) => {
      console.log(tag);
    });
  }, []);
  return (
    <div>
          <Helmet>
            <title>Vertigo Treatment in Delhi, India | Clinic, Cost, Doctor, Care</title>
            <meta name="description" content="Get specialized vertigo treatment in Delhi, India. Learn about causes, diagnosis, therapy, and cost at MedFirst ENT Centre." />
            <meta name="keywords" content="vertigo treatment Delhi, dizziness doctor, balance disorder ENT, vertigo clinic NCR" />
            <link rel="canonical" href="https://entdelhi.com/vertigo-clinic/" />
            <meta property="og:title" content="Vertigo Treatment in Delhi, India | Clinic, Cost, Doctor, Care" />
            <meta property="og:description" content="Get specialized vertigo treatment in Delhi, India. Learn about causes, diagnosis, therapy, and cost at MedFirst ENT Centre." />
            <meta name="robots" content="index, follow" />
            {/* You can add more meta tags as needed */}
          </Helmet>
     <main>
        <Breadcrumb/>
        <Form />    
        <Counter />
         <ContentWithImages/>
         <FollowYt/>
         <DoctorBite/>
         <PatientReviews/>
         
         <GetInTouch/>
      </main>
    </div>
  )
}
